(function () {
  'use strict';
  var TPL = (window.TTTM_P || []).join('\n');
  var THREE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  var modal = null, lastFocus = null;
  function assetsFrom(el) { try { return JSON.parse(el.getAttribute('data-assets')); } catch (e) { return null; } }
  function warm() {
    if (document.getElementById('tttm-dogs-warm')) return;
    var l = document.createElement('link'); l.id = 'tttm-dogs-warm'; l.rel = 'prefetch'; l.as = 'script'; l.href = THREE_URL; document.head.appendChild(l);
  }
  function close() {
    if (!modal) return;
    modal.remove(); modal = null; document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onKey(e) { if (e.key === 'Escape') close(); }
  function open(root, flavor) {
    var A = assetsFrom(root); if (!A) return;
    lastFocus = document.activeElement;
    modal = document.createElement('div');
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-label', 'Meet the pups');
    modal.style.cssText = 'position:fixed;inset:0;z-index:2147483000;background:rgba(20,28,22,.72);display:grid;place-items:center;padding:clamp(8px,3vw,36px);';
    var box = document.createElement('div');
    box.style.cssText = 'position:relative;width:100%;max-width:1180px;height:min(780px,100%);background:#F7F2E8;box-shadow:0 30px 80px rgba(0,0,0,.5);overflow:hidden;';
    var fr = document.createElement('iframe');
    fr.title = 'Interactive Talk Treats To Me bag'; fr.style.cssText = 'border:0;width:100%;height:100%;display:block;';
    var x = document.createElement('button');
    x.type = 'button'; x.setAttribute('aria-label', 'Close'); x.innerHTML = '<svg width="16" height="16" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12"/></svg>';
    x.style.cssText = 'position:absolute;top:10px;right:10px;z-index:2;width:42px;height:42px;border-radius:50%;border:1px solid #1F3A2E;background:#F7F2E8;color:#1F3A2E;cursor:pointer;display:grid;place-items:center;padding:0;';
    x.addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    box.appendChild(fr); box.appendChild(x); modal.appendChild(box); document.body.appendChild(modal);
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    fr.addEventListener('load', function () {
      try {
        var d = fr.contentDocument;
        d.addEventListener('keydown', function (e) { var c = d.getElementById('card'); if (e.key === 'Escape' && c && c.hidden) close(); }, true);
      } catch (err) {}
    });
    fr.srcdoc = TPL.replace('__ASSETS__', function () { return JSON.stringify(A); });
    x.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-tttm-dogs-open]'); if (!t) return;
    e.preventDefault(); open(t.closest('[data-tttm-dogs]'));
  });
  ['pointerenter', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { if (e.target.closest && e.target.closest('[data-tttm-dogs-open]')) warm(); }, { passive: true, capture: true });
  });
})();